module.exports = __webpack_public_path__ + "img/img25.f51f8c55.svg";